import React from 'react';

const BLOCK_TYPES = [
    {
        type: 'heading',
        label: 'Heading',
        icon: (
            <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h7" />
            </svg>
        ),
    },
    {
        type: 'paragraph',
        label: 'Paragraph',
        icon: (
            <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 10h16M4 14h16M4 18h16" />
            </svg>
        ),
    },
    {
        type: 'clause',
        label: 'Clause',
        icon: (
            <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
        ),
    },
    {
        type: 'table',
        label: 'Table',
        icon: (
            <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M3 14h18M10 3v18M14 3v18" />
            </svg>
        ),
    },
    {
        type: 'signature',
        label: 'Signature',
        icon: (
            <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
            </svg>
        ),
    },
    {
        type: 'pagebreak',
        label: 'Page Break',
        icon: (
            <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 12h16M4 6h16M4 18h16" />
            </svg>
        ),
    },
];

const BlocksPalette = ({ onAddBlock }) => {
    return (
        <div>
            <h4>Blocks</h4>
            <div className="blocks-list">
                {BLOCK_TYPES.map((block) => (
                    <button
                        key={block.type}
                        className="block-btn"
                        onClick={() => onAddBlock(block.type)}
                    >
                        {block.icon}
                        <span>{block.label}</span>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default BlocksPalette;
